export function IsPresent (input: string) {
    if (input && input.trim()) {
        return true
    } else {
        return false
    }
}
export function IsValidEmail (input: string) {
    const re = /^\w+([-+.']\w+)*@\w+([-.']\w+)*\.\w+([-.]\w+)*$/ // window.RDL.EmailRegex
    const result = re.test(input)
    return result
}
export function IsValidGuid (input: string) {
    const regExp = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    return regExp.test(input)
}
export function minLength (text: string | any[], minLength: number) {
    const result = text.length
    if (result < minLength) {
        return false
    } else {
        return true
    }
}
